import React, { useEffect, useState } from "react";
import {
  Stack,
  Typography,
  FormGroup,
  FormControlLabel,
  Button,
  Checkbox,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Modal,
  Box,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Navigate, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import routesData from "../shared/routes.json";
import {
  stageDetailsAPICall,
  startOverAPICall,
  termsAndConditionsAPICall,
} from "../shared/APICalls";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import Styles from "../pages/Styles/TermsandConditions.module.scss";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import TickCircle from "../Components/assets/Images/tick-circle.svg";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import BackDrop from "../Components/BackDrop";
import CloseIcon from "@mui/icons-material/Close";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/tandcicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";

const TradingPreferenceSchema = Yup.object().shape({
  tariff: Yup.boolean().oneOf([true], "tariff is required"),
  condition1: Yup.boolean().oneOf([true], "Accept the condition"),
  condition2: Yup.boolean().oneOf([true], "Accept the condition"),
  condition3: Yup.boolean().oneOf([true], "Accept the condition"),
  condition4: Yup.boolean().oneOf([true], "Accept the condition"),
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "max-content",
  // height: "80vh",
  // bgcolor: "background.paper",
  borderRadius: "10px",
  // boxShadow: 24,
  padding: "0px 0px",
};

const Settlements = [
  {
    id: "quarter",
    sequence: 1,
    value: "Quarterly",
  },
  {
    id: "monthly",
    sequence: 2,
    value: "Monthly",
  },
];
const dpselect = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const rta = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const ecs = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const email = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const bsda = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const options = [
  {
    id: "option1",
    sequence: 1,
    value: "Option 1",
  },
  {
    id: "option2",
    sequence: 2,
    value: "Option 2",
  },
];
const sms = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const easi = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const annualreport = [
  {
    id: "physical",
    sequence: 1,
    value: "Physically",
  },
  {
    id: "electronic",
    sequence: 2,
    value: "Electronically",
  },
  {
    id: "both",
    sequence: 3,
    value: "Both Physical and Electronic",
  },
];
const etch = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const dpaccepect = [
  {
    id: true,
    sequence: 1,
    value: "Yes",
  },
  {
    id: false,
    sequence: 2,
    value: "No",
  },
];
const period = [
  {
    id: "daily",
    sequence: 1,
    value: "Daily",
  },
  {
    id: "weekly",
    sequence: 2,
    value: "Weekly",
  },
  {
    id: "fortnightly",
    sequence: 3,
    value: "Fortnightly",
  },
  {
    id: "monthly",
    sequence: 4,
    value: "Monthly",
  },
  {
    id: "as_per_sebi_regulation",
    sequence: 5,
    value: "As per SEBI Regulation",
  },
];

interface props {
  expandTerms?: any;
  settermsandconditions: any;
  setTermsChecked: any;
}

export default function TermsandConditionsPage({
  expandTerms,
  settermsandconditions,
  setTermsChecked,
}: props) {
  const dispatch = useDispatch();
  const [startOverloading, setstartOverloading] = useState(false);
  const [loading, setloading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [backdrop, setBackDrop] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [dropDownValue, setDropDownValue] = useState<any>(Settlements[0]);
  const [dropDownValuedpselect, setDropDownValuedpselect] = useState<any>(
    dpselect[0],
  );
  const [dropDownValuedpaccepect, setDropDownValuedpaccepect] = useState<any>(
    dpaccepect[1],
  );
  const [etchvalue, setetchvalue] = useState<any>(etch[0]);
  const [rtavalue, setrtavalue] = useState<any>(rta[0]);
  const [ecsvalue, setecsvalue] = useState<any>(ecs[0]);
  const [emailvalue, setemailvalue] = useState<any>(email[0]);
  const [smsvalue, setsmsvalue] = useState<any>(sms[0]);
  const [easivalue, seteasivalue] = useState<any>(easi[0]);
  const [bsdavalue, setbsdavalue] = useState<any>(bsda[0]);
  const [optionsvalue, setoptionsvalue] = useState<any>("option2");
  const [annualreportvalue, setannualreportvalue] = useState<any>(
    annualreport[1],
  );
  const [regulationperiod, setregulationperiod] = useState<any>(period[4]);
  const [opentariffModal, setopentariffModal] = useState(false);
  const navigate = useNavigate();
  const navigationData = routesData;
  const [prefilldata, setprefillData] = useState({
    condition1: true,
    condition2: true,
    condition3: true,
    condition4: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    let obj: any = {
      stage: "t_and_c",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        dispatch(setCompletedStages(responseData.data.completed_stages));
        dispatch(setCurrentStage(responseData.data.current_stage));

        setTimeout(() => {
          setprefilloading(false);
        }, 500);

        if (responseData.data.data.terms_and_conditions) {
          const dpfilterd = dpselect.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions.dp_automatic_credit,
          );
          const dpaccepectfilter = dpaccepect.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions
                .accept_all_pledge_instructions,
          );
          const periodfilter = period.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions
                .account_statement_requirement,
          );
          const etchfilter = etch.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions
                .electronic_transaction_holding_statement,
          );
          const emailfilter = email.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions
                .electronic_transaction_holding_statement,
          );
          const annualreportfilter = annualreport.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions.receive_annual_report,
          );
          const bsdafilter = bsda.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions.is_bsda_required,
          );
          const ecsfilter = ecs.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions
                .receive_dividend_to_bank_account,
          );
          const smsfilter = sms.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions
                .mobile_sms_alert_facility,
          );
          const easifilter = easi.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions.easi_facility,
          );
          const rtafilter = rta.filter(
            (a: any) =>
              a.id ===
              responseData.data.data.terms_and_conditions.share_email_with_rta,
          );

          setDropDownValuedpselect(dpfilterd[0]);
          setDropDownValuedpaccepect(dpaccepectfilter[0]);
          setregulationperiod(periodfilter[0] ? periodfilter[0] : period[3]);
          setetchvalue(etchfilter[0]);
          setemailvalue(emailfilter[0]);
          setannualreportvalue(annualreportfilter[0]);
          setbsdavalue(bsdafilter[0]);
          setecsvalue(ecsfilter[0]);
          setsmsvalue(smsfilter[0]);
          seteasivalue(easifilter[0]);
          setrtavalue(rtafilter[0]);
          setoptionsvalue(
            responseData.data.data.terms_and_conditions.dis_booklet ===
              "option_2"
              ? "option2"
              : "option1",
          );
        }
        if (responseData.data.data.is_t_and_c === true) {
          setTermsChecked(true);
          setprefillData((prev) => {
            // console.log("prev", prev);
            return {
              ...prev,
              condition1: true,
              condition2: true,
              condition3: true,
              condition4: true,
            };
          });

          setSelectAll(true);
        }
        if (responseData.data.data.settlement_preference) {
          const preferenceType = Settlements.filter((data) =>
            data.id.includes(responseData.data.data.settlement_preference),
          )[0];
          setDropDownValue(preferenceType);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setprefilloading(false);
      });
  }, []);

  const handleClosetariffModal = () => {
    setopentariffModal(false);
  };
  const handleOpentariffModal = () => {
    setopentariffModal(true);
  };

  useEffect(() => {
    settermsandconditions({
      is_t_and_c: true,
      settlement_preference: dropDownValue.id,
      terms_and_conditions: {
        dp_automatic_credit: dropDownValuedpselect.id,
        accept_all_pledge_instructions: dropDownValuedpaccepect.id,
        account_statement_requirement: regulationperiod.id,
        electronic_transaction_holding_statement: etchvalue.id,
        share_email_with_rta: rtavalue.id,
        receive_annual_report: annualreportvalue.id,
        is_bsda_required: bsdavalue.id,
        receive_dividend_to_bank_account: ecsvalue.id,
        mobile_sms_alert_facility: smsvalue.id,
        dis_booklet: optionsvalue === "option2" ? "option_2" : "option_1",
        easi_facility: easivalue.id,
        elect_trans_of_demat_holding_email: emailvalue.id,
      },
    });
  }, [
    dropDownValue,
    dropDownValuedpselect,
    dropDownValuedpaccepect,
    regulationperiod,
    etchvalue,
    rtavalue,
    annualreportvalue,
    bsdavalue,
    ecsvalue,
    smsvalue,
    optionsvalue,
    easivalue,
    emailvalue,
  ]);

  function termsAndConditions() {
    // console.log("easivalue.id", easivalue);
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitTandC",
      },
    });
    let obj: any = {
      is_t_and_c: true,
      settlement_preference: dropDownValue.id,
      terms_and_conditions: {
        dp_automatic_credit: dropDownValuedpselect.id,
        accept_all_pledge_instructions: dropDownValuedpaccepect.id,
        account_statement_requirement: regulationperiod.id,
        electronic_transaction_holding_statement: etchvalue.id,
        share_email_with_rta: rtavalue.id,
        receive_annual_report: annualreportvalue.id,
        is_bsda_required: bsdavalue.id,
        receive_dividend_to_bank_account: ecsvalue.id,
        mobile_sms_alert_facility: smsvalue.id,
        dis_booklet: optionsvalue === "option2" ? "option_2" : "option_1",
        easi_facility: easivalue.id,
        elect_trans_of_demat_holding_email: emailvalue.id,
      },
    };
    setloading(true);
    termsAndConditionsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", response);
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  }

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                //console.log("responseData", response);
                setstartOverloading(false);
                setBackDrop(false);
                navigate("/");
              })
              .catch((error: any) => {
                setBackDrop(false);
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };

  const handleSelectAllChange = (event, setFieldValue) => {
    const { checked } = event.target;
    setSelectAll(checked);

    setFieldValue("condition1", checked);
    setFieldValue("condition2", checked);
    setFieldValue("condition3", checked);
    setFieldValue("condition4", checked);
  };

  const handleChangeSelectChange = (event: any) => {
    setDropDownValue(event.target.value);
  };

  const InitialValues = {
    condition1: prefilldata.condition1,
    condition2: prefilldata.condition2,
    condition3: prefilldata.condition3,
    condition4: prefilldata.condition4,
  };
  // console.log("rtavalue", rtavalue);
  return (
    <>
      {/* <div className={Styles.step}>
        <img src={keyboardicon} /> Step 2 of 4
      </div>
      <ProgressComp /> */}
      <div className={Styles.mainWrapperTop}>
        <div className={Styles.wrapper}>
          {/* <div
            className={Styles.back}
            onClick={() => {
              navigate("/linkusingifsc");
            }}
          >
            <img src={backicon} /> <span className={Styles.backText}>Back</span>
          </div> */}
          {/* <div className={Styles.step}>
          <img src={keyboardicon} /> Step 6 of 10
        </div> */}
          <div className={Styles.leftContainer}>
            <div className={Styles.headerSection}>
              <p className={Styles.signup}>Terms & Conditions</p>
              {/* <p className={Styles.subText}>
                By pressing continue, you acknowledge and confirm that the
                information provided by you is true & Correct.
              </p> */}
            </div>
            {!prefilloading ? (
              <Formik
                initialValues={InitialValues}
                validationSchema={TradingPreferenceSchema}
                onSubmit={(values) => {
                  // console.log(values);

                  termsAndConditions();
                }}
              >
                {({ values, errors, touched, setFieldValue }) => {
                  // console.log("values", values);
                  {
                    values.condition1 &&
                    values.condition2 &&
                    values.condition3 &&
                    values.condition4
                      ? setSelectAll(true)
                      : setSelectAll(false);
                  }
                  return (
                    <Form>
                      <div>
                        <div className={Styles.mainContainer}>
                          <div className={Styles.contentContaineWrapper}>
                            <div
                              className={Styles.contentContainer}
                              style={{
                                maxHeight: expandTerms ? "3000px" : "",
                              }}
                            >
                              <div className={Styles.checkBoxDiv}>
                                <FormGroup>
                                  <FormControlLabel
                                    sx={{ alignItems: "flex-start" }}
                                    control={
                                      <Checkbox
                                        name="selectAll"
                                        checked={selectAll}
                                        sx={{
                                          padding: "0px",
                                          display: "none",
                                          //marginBottom: "15px",
                                        }}
                                        onChange={(event) =>
                                          handleSelectAllChange(
                                            event,
                                            setFieldValue,
                                          )
                                        }
                                        icon={<PanoramaFishEyeIcon />}
                                        checkedIcon={
                                          <img
                                            src={TickCircle}
                                            width={"24px"}
                                          />
                                        }
                                      />
                                    }
                                    label={
                                      <span className={Styles.label}>
                                        {/* Select All */}
                                      </span>
                                    }
                                  />
                                </FormGroup>
                              </div>
                              <div className={Styles.checkBoxDiv}>
                                <FormGroup>
                                  <FormControlLabel
                                    sx={{ alignItems: "flex-start" }}
                                    control={
                                      <Checkbox
                                        name="condition1"
                                        checked={selectAll || values.condition1}
                                        icon={<PanoramaFishEyeIcon />}
                                        checkedIcon={
                                          <img
                                            src={TickCircle}
                                            width={"24px"}
                                          />
                                        }
                                        sx={{ padding: "0px", display: "none" }}
                                        onChange={(event) => {
                                          const { checked } = event.target;
                                          setFieldValue("condition1", true);
                                        }}
                                      />
                                    }
                                    label={
                                      <span className={Styles.label}>
                                        <span className={Styles.labelspan}>
                                          {" "}
                                          <span>-</span>
                                          <span>
                                            My sole country of tax residency is
                                            India. I / We have understood the
                                            information requirements of this
                                            Form (read along with the{" "}
                                            <a
                                              href="https://firstock-common.s3.ap-south-1.amazonaws.com/ekyc/FATCAforIndividuals.pdf"
                                              target="_blank"
                                              className={Styles.aTag}
                                            >
                                              FATCA & CRS Instructions
                                            </a>
                                            ) and hereby confirm that the
                                            information provided by me/us on
                                            this Form is true, correct, and
                                            complete. I / We also confirm that I
                                            / We have read and understood the
                                            FATCA & CRS Terms and Conditions
                                            below and hereby accept the same.
                                            Name for your account will be
                                            updated as per the Income Tax
                                            database due to Exchange
                                            regulations.
                                          </span>
                                        </span>
                                      </span>
                                    }
                                  />
                                </FormGroup>
                                {errors.condition1 && touched.condition1 && (
                                  <Typography variant="body2" color="error">
                                    {errors.condition1}
                                  </Typography>
                                )}
                              </div>
                              <div className={Styles.checkBoxDiv}>
                                <FormGroup>
                                  <FormControlLabel
                                    sx={{ alignItems: "flex-start" }}
                                    control={
                                      <Checkbox
                                        name="condition2"
                                        sx={{ padding: "0px", display: "none" }}
                                        checked={selectAll || values.condition2}
                                        icon={<PanoramaFishEyeIcon />}
                                        checkedIcon={
                                          <img
                                            src={TickCircle}
                                            width={"24px"}
                                          />
                                        }
                                        onChange={(event) => {
                                          const { checked } = event.target;
                                          setFieldValue("condition2", true);
                                        }}
                                      />
                                    }
                                    label={
                                      <span className={Styles.label}>
                                        <span className={Styles.labelspan}>
                                          {" "}
                                          <span>-</span>{" "}
                                          <span>
                                            {" "}
                                            I authorise FIRSTOCK to operate the
                                            movement of securities from my demat
                                            account for any obligation created
                                            at the Exchange through my
                                            order(s)/trade(s) as per the{" "}
                                            <a
                                              href="https://firstock.in/termsandconditions"
                                              target="_blank"
                                              className={Styles.aTag}
                                            >
                                              Terms & Conditions
                                            </a>{" "}
                                            of the Online Delivery Instruction.
                                          </span>
                                        </span>
                                      </span>
                                    }
                                  />
                                </FormGroup>
                                {errors.condition2 && touched.condition2 && (
                                  <Typography variant="body2" color="error">
                                    {errors.condition2}
                                  </Typography>
                                )}
                              </div>
                              <div className={Styles.checkBoxDiv}>
                                <FormGroup>
                                  <FormControlLabel
                                    sx={{ alignItems: "flex-start" }}
                                    control={
                                      <Checkbox
                                        name="condition3"
                                        sx={{ padding: "0px", display: "none" }}
                                        checked={selectAll || values.condition3}
                                        icon={<PanoramaFishEyeIcon />}
                                        checkedIcon={
                                          <img
                                            src={TickCircle}
                                            width={"24px"}
                                          />
                                        }
                                        onChange={(event) => {
                                          const { checked } = event.target;
                                          setFieldValue("condition3", true);
                                        }}
                                      />
                                    }
                                    label={
                                      <span className={Styles.label}>
                                        <span className={Styles.labelspan}>
                                          {" "}
                                          <span>-</span> I confirm and
                                          understand that my name as per the IT
                                          Department will be taken as my default
                                          FIRSTOCK account name, in case there
                                          is any mismatch of my name as per the
                                          IT department and my name as per the
                                          KRA database/Aadhaar/Bank account. I
                                          further confirm that the linked bank
                                          accounts, Aadhaar, and PAN belong to
                                          me.
                                        </span>
                                      </span>
                                    }
                                  />
                                </FormGroup>
                                {errors.condition3 && touched.condition3 && (
                                  <Typography variant="body2" color="error">
                                    {errors.condition3}
                                  </Typography>
                                )}
                              </div>{" "}
                              <div className={Styles.checkBoxDiv}>
                                <FormGroup>
                                  <FormControlLabel
                                    sx={{ alignItems: "flex-start" }}
                                    control={
                                      <Checkbox
                                        name="condition4"
                                        sx={{ padding: "0px", display: "none" }}
                                        checked={selectAll || values.condition4}
                                        icon={<PanoramaFishEyeIcon />}
                                        checkedIcon={
                                          <img
                                            src={TickCircle}
                                            width={"24px"}
                                          />
                                        }
                                        onChange={(event) => {
                                          const { checked } = event.target;
                                          setFieldValue("condition4", true);
                                        }}
                                      />
                                    }
                                    label={
                                      <span className={Styles.label}>
                                        <span className={Styles.labelspan}>
                                          {" "}
                                          <span>-</span>
                                          <span>
                                            I confirm to have read and
                                            understood the contents of the{" "}
                                            <a
                                              href=" https://firstock-common.s3.ap-south-1.amazonaws.com/ekyc/EquityAnnexure.pdf"
                                              target="_blank"
                                              className={Styles.aTag}
                                            >
                                              Equity Annexure
                                            </a>{" "}
                                            documents.
                                            {/* which include the below annexures:
                                    <span
                                      style={{
                                        color: "#05603A",
                                        padding: "0 3px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      90days
                                    </span>{" "} */}
                                          </span>
                                        </span>
                                      </span>
                                    }
                                  />
                                </FormGroup>
                                {errors.condition4 && touched.condition4 && (
                                  <Typography variant="body2" color="error">
                                    {errors.condition4}
                                  </Typography>
                                )}
                              </div>
                              {expandTerms && (
                                <>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>{" "}
                                              <span>
                                                {" "}
                                                As per{" "}
                                                <span
                                                  style={{ color: "#3263E5" }}
                                                >
                                                  <a
                                                    href="https://www.meity.gov.in/static/uploads/2024/06/2bf1f0e9f04e6fb4f8fef35e82c42aa5.pdf"
                                                    target="_blank"
                                                    className={Styles.aTag}
                                                  >
                                                    “Digital Personal Data
                                                    Protection Act”
                                                  </a>
                                                </span>
                                                , 2023 all the Reporting
                                                Entities registered with CKYCRR
                                                were requested to obtain the
                                                consent from the customer for
                                                downloading their CKYC record
                                                from CKYCRR. Therefore,
                                                obtaining customer consent is
                                                also mandatory as per RBI Master
                                                Directions for the entities
                                                regulated by RBI. This means
                                                that when you sign up for a
                                                service or become a client of a
                                                Firstock Broking Private
                                                Limited, subject to KYC
                                                regulations, you automatically
                                                agree to allow them to access
                                                your KYC records stored in the
                                                CKYCR.
                                              </span>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>
                                              <span>
                                                {" "}
                                                I Confirm to take the settlement
                                                of my unused funds on every{" "}
                                                <FormControl size="small">
                                                  <Select
                                                    style={{ width: "75px" }}
                                                    inputProps={{
                                                      IconComponent: () => "",
                                                    }}
                                                    disableUnderline
                                                    MenuProps={{
                                                      PaperProps: {
                                                        sx: {
                                                          borderRadius: "10px",
                                                          "& li.Mui-selected": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                            fontSize: "12px",
                                                          },
                                                        },
                                                      },
                                                      MenuListProps: {
                                                        sx: {
                                                          "& .MuiPaper-root": {
                                                            borderRadius:
                                                              "10px",
                                                          },

                                                          "& li.Mui-selected": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                            fontSize: "12px",
                                                            "&:hover": {
                                                              backgroundColor:
                                                                "#1F2937",
                                                              color: "white",
                                                            },
                                                          },
                                                        },
                                                      },
                                                    }}
                                                    sx={{
                                                      fontSize: "12px",
                                                      marginTop: "-3px",
                                                      color: "#3263E5",
                                                      fontWeight: 500,
                                                      boxShadow: "none",
                                                      ".MuiSvgIcon-root-393": {
                                                        visibility: "hidden",
                                                      },
                                                      ".MuiOutlinedInput-input":
                                                        {
                                                          padding:
                                                            "3.5px 5px !important",
                                                        },
                                                      ".MuiOutlinedInput-notchedOutline":
                                                        {
                                                          border: 0,
                                                        },
                                                      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                        {
                                                          border: 0,
                                                        },
                                                      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                        {
                                                          border: 0,
                                                        },
                                                    }}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={dropDownValue}
                                                    label=""
                                                    onChange={(event) => {
                                                      handleChangeSelectChange(
                                                        event,
                                                      );
                                                    }}
                                                  >
                                                    {Settlements.map(
                                                      (
                                                        data: any,
                                                        index: any,
                                                      ) => {
                                                        // console.log(data)
                                                        return (
                                                          <MenuItem
                                                            value={data}
                                                            key={index}
                                                          >
                                                            {data.value}
                                                          </MenuItem>
                                                        );
                                                      },
                                                    )}
                                                  </Select>
                                                </FormControl>
                                                basis from my FIRSTOCK trading
                                                account.
                                              </span>{" "}
                                            </span>{" "}
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>{" "}
                                              <span>
                                                {" "}
                                                I instruct the DP to receive
                                                each and every credit in my
                                                account:
                                                <FormControl size="small">
                                                  <Select
                                                    style={{ width: "45px" }}
                                                    inputProps={{
                                                      IconComponent: () => "",
                                                    }}
                                                    disableUnderline
                                                    MenuProps={{
                                                      PaperProps: {
                                                        sx: {
                                                          borderRadius: "10px",
                                                          "& li.Mui-selected": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                            fontSize: "12px",
                                                          },
                                                        },
                                                      },
                                                      MenuListProps: {
                                                        sx: {
                                                          "& .MuiPaper-root": {
                                                            borderRadius:
                                                              "10px",
                                                          },

                                                          "& li.Mui-selected": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                            fontSize: "12px",
                                                            "&:hover": {
                                                              backgroundColor:
                                                                "#1F2937",
                                                              color: "white",
                                                            },
                                                          },
                                                        },
                                                      },
                                                    }}
                                                    sx={{
                                                      fontSize: "12px",
                                                      marginTop: "-3px",
                                                      color: "#3263E5",
                                                      fontWeight: 500,
                                                      boxShadow: "none",
                                                      ".MuiSvgIcon-root-393": {
                                                        visibility: "hidden",
                                                      },
                                                      ".MuiOutlinedInput-input":
                                                        {
                                                          padding:
                                                            "3.5px 5px !important",
                                                        },
                                                      ".MuiOutlinedInput-notchedOutline":
                                                        {
                                                          border: 0,
                                                        },
                                                      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                        {
                                                          border: 0,
                                                        },
                                                      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                        {
                                                          border: 0,
                                                        },
                                                    }}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={
                                                      dropDownValuedpselect
                                                    }
                                                    label=""
                                                    onChange={(event) => {
                                                      setDropDownValuedpselect(
                                                        event.target.value,
                                                      );
                                                    }}
                                                  >
                                                    {dpselect.map(
                                                      (
                                                        data: any,
                                                        index: any,
                                                      ) => {
                                                        // console.log(data)
                                                        return (
                                                          <MenuItem
                                                            value={data}
                                                            key={index}
                                                          >
                                                            {data.value}
                                                          </MenuItem>
                                                        );
                                                      },
                                                    )}
                                                  </Select>
                                                </FormControl>
                                                {/* basis from my NCO securities trading
                                      account. */}
                                              </span>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span> I would like to
                                              instruct the DP to accept all the
                                              pledge instructions in my account
                                              without any other Further
                                              instruction from my end:
                                              <FormControl size="small">
                                                <Select
                                                  style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={
                                                    dropDownValuedpaccepect
                                                  }
                                                  label=""
                                                  onChange={(event) => {
                                                    setDropDownValuedpaccepect(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {dpaccepect.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                            </span>
                                            {/* basis from my NCO securities trading
                                      account. */}
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span> Account Statement
                                              Requirement :
                                              <FormControl size="small">
                                                <Select
                                                  // style={{ width: "105px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={regulationperiod}
                                                  label=""
                                                  onChange={(event) => {
                                                    setregulationperiod(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {period.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                              {/* basis from my NCO securities trading
                                      account. */}
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>

                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span> I request you to
                                              send Electronic
                                              Transaction-cum-Holding Statement
                                              at the email ID:
                                              <FormControl size="small">
                                                <Select
                                                  style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={etchvalue}
                                                  label=""
                                                  onChange={(event) => {
                                                    setetchvalue(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {etch.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                              {/* basis from my NCO securities trading
                                      account. */}
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>

                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>I would like to
                                              share the email ID with the RTA:
                                              <FormControl size="small">
                                                <Select
                                                  style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={rtavalue}
                                                  label=""
                                                  onChange={(event) => {
                                                    setrtavalue(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {rta.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                              {/* basis from my NCO securities trading
                                      account. */}
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>

                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>I would like to
                                              receive the Annual Report:
                                              <FormControl size="small">
                                                <Select
                                                  // style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={annualreportvalue}
                                                  label=""
                                                  onChange={(event) => {
                                                    setannualreportvalue(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {annualreport.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                              {/* basis from my NCO securities trading
                                      account. */}
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>

                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span> I/We wish to
                                              receive dividend interest directed
                                              into my bank account as given
                                              below through ECS:
                                              <FormControl size="small">
                                                <Select
                                                  style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={ecsvalue}
                                                  label=""
                                                  onChange={(event) => {
                                                    setecsvalue(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {ecs.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span> I request you to
                                              send Electronic Transaction cum
                                              Holding statement of my Demat
                                              Account through EMAIL:
                                              <FormControl size="small">
                                                <Select
                                                  style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={emailvalue}
                                                  label=""
                                                  onChange={(event) => {
                                                    setemailvalue(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {email.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>I wish to avail
                                              Trust Facility using the Mobile
                                              number Registered for SMS alert
                                              Facility:
                                              <FormControl size="small">
                                                <Select
                                                  style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={smsvalue}
                                                  label=""
                                                  onChange={(event) => {
                                                    setsmsvalue(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {sms.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>I would like to
                                              register for EASI Facility from
                                              CDSL INDIA:
                                              <FormControl size="small">
                                                <Select
                                                  style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={easivalue}
                                                  label=""
                                                  onChange={(event) => {
                                                    seteasivalue(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {easi.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>

                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition4"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition4
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition4", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>
                                              <span>
                                                <a
                                                  className={Styles.aTag}
                                                  // onClick={handleOpentariffModal}
                                                  href="https://firstock-common.s3.ap-south-1.amazonaws.com/ekyc/TradingTariff.pdf"
                                                  target="_blank"
                                                >
                                                  {" "}
                                                  View
                                                </a>{" "}
                                                Trading tariff details
                                              </span>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition4 &&
                                      touched.condition4 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition4}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition4"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition4
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition4", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>
                                              <span>
                                                <a
                                                  className={Styles.aTag}
                                                  href="https://firstock-common.s3.ap-south-1.amazonaws.com/ekyc/BrokingTariff.pdf"
                                                  target="_blank"
                                                >
                                                  {" "}
                                                  View
                                                </a>{" "}
                                                DP Tariff details
                                              </span>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition4 &&
                                      touched.condition4 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition4}
                                        </Typography>
                                      )}
                                  </div>

                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>I would wish to
                                              avail the following facility:
                                              Basic Service Demat Account
                                              Faciality (BSDA):
                                              <FormControl size="small">
                                                <Select
                                                  style={{ width: "45px" }}
                                                  inputProps={{
                                                    IconComponent: () => "",
                                                  }}
                                                  disableUnderline
                                                  MenuProps={{
                                                    PaperProps: {
                                                      sx: {
                                                        borderRadius: "10px",
                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                        },
                                                      },
                                                    },
                                                    MenuListProps: {
                                                      sx: {
                                                        "& .MuiPaper-root": {
                                                          borderRadius: "10px",
                                                        },

                                                        "& li.Mui-selected": {
                                                          backgroundColor:
                                                            "#1F2937",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          "&:hover": {
                                                            backgroundColor:
                                                              "#1F2937",
                                                            color: "white",
                                                          },
                                                        },
                                                      },
                                                    },
                                                  }}
                                                  sx={{
                                                    fontSize: "12px",
                                                    marginTop: "-3px",
                                                    color: "#3263E5",
                                                    fontWeight: 500,
                                                    boxShadow: "none",
                                                    ".MuiSvgIcon-root-393": {
                                                      visibility: "hidden",
                                                    },
                                                    ".MuiOutlinedInput-input": {
                                                      padding:
                                                        "3.5px 5px !important",
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                      {
                                                        border: 0,
                                                      },
                                                  }}
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={bsdavalue}
                                                  label=""
                                                  onChange={(event) => {
                                                    setbsdavalue(
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  {bsda.map(
                                                    (data: any, index: any) => {
                                                      // console.log(data)
                                                      return (
                                                        <MenuItem
                                                          value={data}
                                                          key={index}
                                                        >
                                                          {data.value}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </FormControl>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>

                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name="condition3"
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            onChange={(event) => {
                                              const { checked } = event.target;
                                              setFieldValue("condition3", true);
                                            }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>Option form for
                                              issue of DIS Booklet (Voluntary):
                                              <a
                                                className={Styles.aTag}
                                                onClick={handleOpentariffModal}
                                              >
                                                {" "}
                                                {optionsvalue === "option2"
                                                  ? "Option 2"
                                                  : "Option 1"}
                                              </a>
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name=""
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            // onChange={(event) => {
                                            //   const { checked } = event.target;
                                            //   setFieldValue("condition3", true);
                                            // }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>I am a Resident of
                                              India
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name=""
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                            // onChange={(event) => {
                                            //   const { checked } = event.target;
                                            //   setFieldValue("condition3", true);
                                            // }}
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span>9 out of 10
                                              individual traders in equity
                                              Futures and Options Segment,
                                              incurred net losses.
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name=""
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span> On an average, loss
                                              makers registered net trading loss
                                              close to ₹50,000.
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name=""
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span> Over and above the
                                              net trading losses incurred, loss
                                              makers expended an additional 28%
                                              of net trading losses as
                                              transaction costs.
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv}>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name=""
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                          />
                                        }
                                        label={
                                          <span className={Styles.label}>
                                            <span className={Styles.labelspan}>
                                              {" "}
                                              <span>-</span> Those making net
                                              trading profits, incurred between
                                              15% to 50% of such profits as
                                              transaction cost. costs.
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                  <div className={Styles.checkBoxDiv} style={{paddingLeft:"2px"}} >
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{ alignItems: "flex-start" }}
                                        control={
                                          <Checkbox
                                            name=""
                                            sx={{
                                              padding: "0px",
                                              display: "none",
                                            }}
                                            checked={
                                              selectAll || values.condition3
                                            }
                                            icon={<PanoramaFishEyeIcon />}
                                            checkedIcon={
                                              <img
                                                src={TickCircle}
                                                width={"24px"}
                                              />
                                            }
                                          />
                                        }
                                        label={
                                          <span className={Styles.label} >
                                            <span className={Styles.labelspanLast} >
                                              {" "}
                                              Source:{" "}
                                              <a
                                                href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html"
                                                target="_blank"
                                                className="riskdisclosureatag"
                                              >
                                                SEBI study{" "}
                                              </a>{" "}
                                              dated january 25, 2023 on
                                              "Analysis of Profit and Loss of
                                              Individual Traders dealing in
                                              equity Futures and Options (F&O)
                                              Segment",wherein Aggregate Level
                                              findings are based on annual
                                              Profit/Loss invurred by individual
                                              traders in equity F&O during FY
                                              2021-22.
                                            </span>
                                          </span>
                                        }
                                      />
                                    </FormGroup>
                                    {errors.condition3 &&
                                      touched.condition3 && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                        >
                                          {errors.condition3}
                                        </Typography>
                                      )}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        {backdrop && <StartOverBackDrop />}
                        {/* <div className={Styles.buttonStack}>
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {(values.condition1 &&
                              values.condition2 &&
                              values.condition3 &&
                              values.condition4) ||
                            selectAll ? (
                              <LoadingButton
                                variant="contained"
                                type="submit"
                                loading={loading}
                                id="termsandconditionsContinueButton"
                                className={Styles.approveButton}
                                sx={{ height: "50px" }}
                              >
                                Continue
                              </LoadingButton>
                            ) : (
                              <Button
                                variant="contained"
                                type="submit"
                                disabled
                                className={Styles.approveButton}
                                sx={{ height: "50px" }}
                              >
                                Continue
                              </Button>
                            )}
                          </div>
                        </div> */}
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            ) : (
              <div style={{ height: "100vh" }}>
                <BackDrop />
              </div>
            )}
          </div>
          <Modal
            open={opentariffModal}
            onClose={handleClosetariffModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className={Styles.tablewrapper}>
                <h4 style={{ margin: 0, textDecoration: "underline" }}>
                  Select Options
                </h4>
                <IconButton
                  size="small"
                  sx={{ position: "absolute", right: "10px", top: "10px" }}
                  onClick={handleClosetariffModal}
                >
                  <CloseIcon />
                </IconButton>

                {/* <table className={Styles.tablemain}>
                <tr>
                  <th className={Styles.tablehead}>Charge Head</th>
                  <th className={Styles.tablehead}>Brokerage/Charges</th>
                </tr>

                {tariff.map((a: any) => (
                  <tr>
                    <td className={Styles.tablebodyhead}>{a.chargehead}</td>
                    <td className={Styles.tablebodyhead}>{a.charges}</td>
                  </tr>
                ))}
              </table> */}
                <div className={Styles.tablemain}>
                  <div className={Styles.checkBoxDiv}>
                    <FormGroup>
                      <FormControlLabel
                        sx={{ alignItems: "flex-start" }}
                        control={
                          <Checkbox
                            name="condition3"
                            sx={{ padding: "0px" }}
                            checked={optionsvalue === "option1"}
                            icon={<PanoramaFishEyeIcon />}
                            checkedIcon={
                              <img src={TickCircle} width={"24px"} />
                            }
                            onChange={(event) => {
                              const { checked } = event.target;
                              setoptionsvalue(checked ? "option1" : "option2");
                            }}
                          />
                        }
                        label={
                          <span className={Styles.label}>
                            <span style={{ fontFamily: "inherit !important" }}>
                              {" "}
                              <span
                                style={{
                                  fontWeight: "bold",
                                  fontFamily: "inherit !important",
                                }}
                              >
                                Option 1
                              </span>
                              : I/We require you to issue Delivery Instruction
                              Slip (DIS) booklet to me/us immediately on opening
                              my/our CDSL account though I/We have issued a
                              Power of Attorney (POA) in favor of Firstock
                              Broking Pvt. Ltd. for executing delivery
                              instructions for settling stock exchange trades
                              (Settlement related transactions) effected through
                              such Clearing Member.
                            </span>

                            {/* basis from my NCO securities trading
                                      account. */}
                          </span>
                        }
                      />
                    </FormGroup>
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    (Or)
                  </p>
                  <div className={Styles.checkBoxDiv}>
                    <FormGroup>
                      <FormControlLabel
                        sx={{ alignItems: "flex-start" }}
                        control={
                          <Checkbox
                            name="condition3"
                            sx={{ padding: "0px" }}
                            checked={optionsvalue === "option2"}
                            icon={<PanoramaFishEyeIcon />}
                            checkedIcon={
                              <img src={TickCircle} width={"24px"} />
                            }
                            onChange={(event) => {
                              const { checked } = event.target;
                              setoptionsvalue(checked ? "option2" : "option1");
                            }}
                          />
                        }
                        label={
                          <span className={Styles.label}>
                            <span>
                              {" "}
                              <span style={{ fontWeight: "bold" }}>
                                Option 2
                              </span>
                              : I/We do not require Delivery Instruction Slip
                              (DIS) for the time being. Since I/We have issued a
                              POA/EDIS in favor of Firstock Broking Pvt. Ltd.
                              for executing delivery instructions for settling
                              stock exchange trades (Settlement related
                              transactions) effected through such Clearing
                              Member. However, the Delivery Instruction Slip
                              (DIS) booklet should be issued to me/us
                              immediately on my/our request at any later date.
                            </span>

                            {/* basis from my NCO securities trading
                                      account. */}
                          </span>
                        }
                      />
                    </FormGroup>
                  </div>
                </div>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}
